/* mm-core.js
   Loader léger : charge mm-search / mm-pdp / mm-collection uniquement si nécessaire
   ✅ Optimisé : PDP/Collection chargés ASAP (pas d'attente DOMContentLoaded)
*/
(function () {
  function load(src) {
    return new Promise(function (resolve, reject) {
      if (!src) return resolve();
      // évite double load
      if (document.querySelector('script[data-mm-loaded="' + src + '"]')) return resolve();

      var s = document.createElement("script");
      s.src = src;
      s.async = true; // dynamique => async réel
      s.setAttribute("data-mm-loaded", src);
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function boot() {
    var root = document.documentElement;
    var body = document.body;
    if (!body) return;

    // 1) Search custom (si présent dans le DOM)
    if (document.querySelector("[data-mm-search]")) {
      load(root.getAttribute("data-mm-search-src"));
    }

// 2) PDP
if (body.classList.contains("template-product")) {
  load(root.getAttribute("data-mm-pdp-src"));
  return; // PDP prioritaire
}

    // 3) Collection
    if (body.classList.contains("template-collection")) {
      load(root.getAttribute("data-mm-collection-src"));
    }
  }

  // ✅ si mm-core est en bas du body => body existe, on lance direct
  if (document.readyState === "loading") {
    // on tente ASAP, puis à DOMContentLoaded au cas où
    try { boot(); } catch (e) {}
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();